import moment from 'moment';

/**
 * @name eventStartEndFormat
 * @desc Parse event's start & end dates to clean format.
 * @param {object} event
 * @return object
 */
export default function eventStartEndFormat(event) {

    let output = '';
    const { eventStarts, eventEnds } = event;

    if(!eventStarts && !eventEnds) {
        return output;
    }

    const startMoment = moment(eventStarts);

    if(eventStarts && eventEnds) {

        const endMoment = moment(eventEnds);
        const sameDay = startMoment.isSame(endMoment, 'day');
        const sameMonth = startMoment.isSame(endMoment, 'month');

        // Single day event
        if(sameDay) {
            output = startMoment.format('DD.MM.YYYY');
        } else {
            // Same month
            if(sameMonth) {
                output += startMoment.format('DD.');
            }
            // Not same month
            else {
                output += startMoment.format('DD.MM.');
            }
            // Add end date
            output += '-';
            output += endMoment.format('DD.MM.YYYY');
        }
    } else if (!eventEnds) {
        output += startMoment.format('DD.MM.YYYY');
    }


    return output;
}